<template>
  <div class="wrap" :class="tradeMethod">
    <van-nav-bar :title="navTitle" left-arrow @click-left="$router.back()" />
    <div class="detailInfo">
      <div class="top_bar">
        <div class="title">
          <span class="text">{{ detailData.title || "" }}</span>
          <i class="iconfont icon-iconfontanquan" style="color: #29c59c"></i>
        </div>
        <i class="iconfont icon-yinhangqia"></i>
      </div>
      <div class="line">
        <span class="label">{{ $t("p2p.coinList.label.price") }}</span>
        <span class="price_value">{{
          $money(detailData.price || "0.00", true, "C$")
        }}</span>
        <!-- <span class="price_value">{{ `${toMoney(1)} ${userInfo.currency_code}` }}</span> -->
      </div>
      <div class="line">
        <span class="label">{{ $t("p2p.coinList.label.amount") }}</span>
        <span class="value">{{
          `${detailData.amount || 0.0} ${coinType}`
        }}</span>
      </div>
      <div class="line">
        <span class="label">{{ $t("p2p.coinList.label.limit") }}</span>
        <span class="value">{{ detailData.limit }}</span>
      </div>
    </div>
    <div class="trade">
      <div class="title">
        {{ $t("p2p.tradeDetails.trade_title_" + tradeMethod, { __: coinType }) }}
      </div>
      <div class="input_wrap">
        <input
          type="text"
          v-model="moneyAmount"
          @input="moneyInput"
          placeholder="0.00"
        />
        <div class="right">
          <!-- <div class="unit">{{ userInfo.currency_code || "" }}</div> -->
          <div class="unit">CAD</div>
          <div class="btn_all" @click="handleAll('money')">
            {{ $t("common.all") }}
          </div>
        </div>
      </div>
      <div class="input_wrap">
        <input
          type="text"
          v-model="coinAmount"
          placeholder="0.00"
          @input="coinInput"
        />
        <div class="right">
          <div class="unit">{{ coinType || "" }}</div>
          <div class="btn_all" @click="handleAll('coin')">
            {{ $t("common.all") }}
          </div>
        </div>
      </div>
      <!-- <div class="balance">
        {{ `${$t('availableBalance')}: ${$money(balance, false)} ${userInfo.currency_code || "USD"}` }}
      </div> -->
    </div>
    <div class="bottom_bar">
      <div class="content">
        <van-button
          block
          :color="
            tradeMethod === 'buy' ? 'var(--trade-green)' : 'var(--trade-red)'
          "
          style="border-radius: 4px"
          @click="handleSubmit"
        >
          {{
            $t("p2p.tradeDetails.submit_now", {
              __: tradeMethodText,
            })
          }}
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
import tradeMethods from "./tradeMethods.json";
import { NavBar, Button } from "vant";
import { $post, $get, dealError } from "@/utils";
import { mapGetters } from "vuex";
export default {
  components: {
    [NavBar.name]: NavBar,
    [Button.name]: Button,
  },
  data() {
    return {
      navTitle: "",
      detailData: {},
      coinType: "",
      tradeMethod: "",
      tradeMethodText: "",
      moneyAmount: "",
      coinAmount: "",
      coinId: "",
    };
  },
  computed: {
    ...mapGetters(["userInfo", "unitData", "coins"]),
    coinList() {
      return this.$store.getters.coinList(this.tradeMethod);
    },
    balance() {
      const unitItem = this.unitData.find(
        (item) => item.code === this.userInfo.currency_code
      );
      if (unitItem && this.userInfo) {
        return (this.userInfo.money / unitItem.rate).toFixed(2);
      }
      return "0.00";
    },
  },
  mounted() {
    const { type, coinType, id } = this.$route.query;
    const typeText = tradeMethods.find((item) => item.value === type).title;
    this.tradeMethodText = this.$t(typeText);
    this.navTitle = `${this.$t(typeText)} ${coinType}`;
    this.coinType = coinType;
    this.tradeMethod = type;
    this.coinId = id;
    this.getData(id);
  },
  // watch: {
  //   moneyAmount(val) {
  //     if (val) {
  //       console.log(val, this.coinAmount);
  //     }
  //   }
  // },
  methods: {
    async getData(id) {
      try {
        const { ret, msg, data } = await $get("/ptop/lists", { id });
        this.detailData = data;
      } catch (error) {
        dealError(error);
      }
    },
    moneyInput(e) {
      const val = e.target.value;
      this.coinAmount = this.toCoin(val);
    },
    coinInput(e) {
      const val = e.target.value;
      this.moneyAmount = this.toMoney(val);
    },
    // toCoin(val) {
    //   const unitItem = this.unitData.find(item => item.code === this.userInfo.currency_code);
    //   const coinItem = this.coins.find(item => item.value === this.coinType);
    //   if (unitItem && coinItem) {
    //     const usdtAmount = val * unitItem.rate;
    //     const coinAmount = usdtAmount / coinItem.rate;
    //     return this.fixed(coinAmount);
    //   }
    //   return "";
    // },
    toCoin(val) {
      return this.fixed(val / this.detailData.price);
    },
    toMoney(val) {
      return this.fixed(val * this.detailData.price);
    },
    // toMoney(val) {
    //   const unitItem = this.unitData.find(item => item.code === this.userInfo.currency_code);
    //   const coinItem = this.coins.find(item => item.value === this.coinType);
    //   if (unitItem && coinItem) {
    //     const usdtAmount = val / unitItem.rate;
    //     const moneyAmount = usdtAmount * coinItem.rate;
    //     return this.fixed(moneyAmount);
    //   }
    //   return "";
    // },
    handleAll(type) {
      this.moneyAmount = this.balance;
      this.coinAmount = this.toCoin(this.balance);
      // switch (type) {
      //   case "money":
      //     this.moneyAmount = this.userInfo.money;
      //     break;

      //   default:
      //     break;
      // }
    },
    handleSubmit() {
      if (!Number(this.coinAmount)) return;
      this.$router.push(
        `/coinOrderDetail?type=${this.tradeMethod}&coinType=${this.coinType}&id=${this.coinId}&amount=${this.coinAmount}`
      );
    },
  },
};
</script>

<style lang="less" scoped>
@comMargin: calc(13rem / 16);
@grey: #999;

.detailInfo {
  margin: calc(20rem / 16) @comMargin 0;
  border-radius: 8px;
  padding: @comMargin;
  // background-color: var(--theme);
  background-color: #fff;
  // color: #fff;
  font-size: calc(14rem / 16);
  // @grey: rgba(255, 255, 255, .6);

  .top_bar {
    display: flex;
    justify-content: space-between;
    align-items: center;

    > .title {
      font-size: calc(14rem / 16);
    }

    > img {
      @size: calc(24rem / 16);
      width: @size;
    }

    > .iconfont {
      font-size: calc(24rem / 16);
      color: #ffb628;
    }
  }

  .line {
    margin-top: calc(6rem / 16);

    .label {
      color: @grey;
      margin-right: calc(8rem / 16);
    }

    .price_value {
      // color: #FF4040;
      font-size: calc(16rem / 16);
    }
  }
}

.trade {
  padding: @comMargin;

  .title {
    font-size: calc(15rem / 16);
  }

  .input_wrap {
    margin-top: calc(16rem / 16);
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: calc(8rem / 16);
    border-radius: 4px;
    background-color: #fff;

    &:nth-child(2) {
      margin-top: calc(8rem / 16);
    }

    input {
      border: none;
      font-size: calc(15rem / 16);
    }

    .right {
      display: flex;
      font-size: calc(14rem / 16);

      .unit {
        @gap: calc(12rem / 16);
        color: @grey;
        padding-right: @gap;
        margin-right: @gap;
        border-right: 1px solid rgba(0, 0, 0, 0.2);
      }

      .btn_all {
        color: #01bd8d;
      }
    }
  }

  .balance {
    font-size: calc(12rem / 16);
    margin-top: calc(6rem / 16);
    color: @grey;
  }
}

.bottom_bar {
  position: fixed;
  bottom: calc(30rem / 16);
  overflow: hidden;
  width: 100vw;
  max-width: 750px;

  .content {
    margin: @comMargin;
  }
}
.buy {
  .price_value {
    color: var(--trade-green);
  }
}
</style>